'use strict';

export default class GpsFormat {
    /**
     *
     * @param {Number} n
     * @param {Number} e
     * @return {string}
     */
    static formatGps([n, e] = []){
        return `${n || 0}N, ${e || 0}E`;
    }
}
